/**
 * TanStack Router: /financial/payroll-lookup
 *
 * Admin route for looking up employee payroll information
 * from PainelGerencial via tRPC.
 */
import { createFileRoute } from '@tanstack/react-router'
import { PayrollLookupPage } from '../../../app/financial/payroll-lookup'

export const Route = createFileRoute('/_auth/financial/payroll-lookup')({
  component: PayrollLookupPage,
})
